<template>
	<div class="drawer">
		<el-drawer size="550px" title="会员卡信息" :visible.sync="drawerStatus" @close='close'>

			<div style="height: 50px;width:100%;margin-left: 70px;">
				<div class="item" v-for="(item, index) in CardList" :key="index" :class="getClass(index)"
					@click="submit(item)">
					<div class="left">
						<div class="ItemA" style="font-weight: 700;">
							<div>花生宠物{{ item.title }}</div>
						</div>
						<div>{{ item.remark }}</div>
						<div>有效期：{{ item.days }}天</div>
						<div style="color: #ffae11;font-weight: 500;font-size: 18px;">￥{{ item.price }}.00</div>
					</div>
					<div class="right" :class="getClass1(index)"></div>
				</div>
			</div>
			<!-- <div class="btnBox">
				<div>总计</div>
				<div class="btnItem submit" @click="submit">生成订单</div>
			</div> -->
		</el-drawer>
	</div>
</template>
<script>
export default {
	data() {
		return {
			drawerStatus: false,
			CardList: [],
			tableDate: [],
			flag: false,
		}
	},
	computed: {
		saleList() {
			return this.$store.state.mendian.saleList;
		}
	},
	props: {

	},
	watch: {

	},
	mounted() {
		this.$nextTick(() => { this.drawerStatus = true })
		this.getCardlist()
		this.saleList.forEach((ele, index) => {
			console.log(ele.goodsType);
			if (ele.goodsType == 12) {
				this.flag = true
				this.$message({
					message: "购物车中已选有会员卡,请先删除",
					type: "error",
				});
				return;
			}
		})
	},
	methods: {
		getClass(index) {

			return 'block' + (index + 1);

		},
		getClass1(index) {

			return 'ass' + (index + 1);

		},
		getCardlist() {
			this.$http.get(process.env.VUE_APP_apiHost + 'api/Product/VipCard/List').then(res => {
				if (res.code == 0) {
					this.CardList = res.data
				}
			})
		},
		close() {
			this.$emit('submit', {})
		},

		submit(item) {
			console.log(item, this.flag, 'item');
			if (this.flag) {
				return;
			} else {
				if (item && item._id) {
					this.$emit('submit', { id: item._id })
					this.$store.dispatch('mendian/getCardDetail', { id: item._id })
				}

			}

		},
	}
}
</script>
<style lang="scss" scoped>
.item {
	width: 400px;
	// height: 136px;
	margin: 25px 0;
	font-size: 14px;
	color: #0a0a0a;
	padding: 15px 20px;
	line-height: 28px;
	display: flex;
	justify-content: space-around;
	align-items: center;

}
.left{
	width: 70%;

}

.block1 {
	background: #F5FAFF;
	border-radius: 12px;
	border: 1px solid #DFDFDF;
}

.block2 {
	background: #FFF5F5;
	border-radius: 12px;
	border: 1px solid #DFDFDF;
}

.block3 {
	background: #FFFAF5;
	border-radius: 12px;
	border: 1px solid #DFDFDF;
}

.ass1 {
	width: 125px;
	height: 86px;
	background-image: url(../../assets/img/mendian/yueCard.png);
	background-size: 100%;
	background-repeat: no-repeat;
}

.ass2 {
	width: 125px;
	height: 86px;
	background-image: url(../../assets/img/mendian/jiCard.png);
	background-size: 100%;
	background-repeat: no-repeat;
}

.ass3 {
	width: 125px;
	height: 86px;
	background-image: url(../../assets/img/mendian/nianCard.png);
	background-size: 100%;
	background-repeat: no-repeat;
}

.ItemA {
	display: flex;
	justify-content: space-between;
	font-size: 18px;

}

.drawer {
	::v-deep .el-drawer__body {
		overflow-y: auto;
		padding-bottom: 30px;

		.el-form-item {
			margin-bottom: 8px;
		}
	}
}

.btnBox {
	width: 100%;
	border-top: 1px solid #e8e5e5;
	font-size: 14px;
	color: #121111;
	line-height: 40px;
	display: flex;
	justify-content: space-around;
	padding: 20px 0;
	position: absolute;
	bottom: 0;
	z-index: 10;

	.btnItem {
		text-align: center;
		width: 100px;
		cursor: pointer;

		&.submit {
			border-radius: 30px;
			color: aliceblue;
		}
	}
}
</style>
